import { useQuery } from "@tanstack/react-query";
import { getWhyChooseUsSection } from "../../api/apiWhyChooseUs";

export const useGetWhyChooseUsSection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["why-choose-us-section"],
        queryFn: getWhyChooseUsSection,
    });

    return {
        whyChooseUsSection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
